import {Component, Inject, OnInit, Optional, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Compbaser} from "../../../components/compbaser";
import {NgxFlickingComponent} from "@egjs/ngx-flicking";
import {timeout} from "../../../decorators/timeout";

export interface IDialogAssetViewer {
    videos: Array<string>;
    images: Array<string>;
    autoMoveNext: boolean;
    autoMoveNextTime: number;
}

@Component({
    selector: 'app-dialog-asset-viewer',
    templateUrl: './dialog-asset-viewer.component.html',
    styleUrls: ['./dialog-asset-viewer.component.scss']
})
export class DialogAssetViewerComponent extends Compbaser implements OnInit {

    @ViewChild(NgxFlickingComponent) flick: NgxFlickingComponent;
    popupMode;
    images = [];
    videos = [];
    someVar = '';
    disabled;
    totalOf;
    m_data: IDialogAssetViewer;
    ready;
    imageLoading = true;

    constructor(@Optional() @Inject(MAT_DIALOG_DATA) data) {
        super();
        this.m_data = data;
        this.images = this.m_data.images;
        this.videos = this.m_data.videos;
    }

    ngOnInit(): void {
        this.init();
    }

    @timeout()
    init() {
        if (this.m_data) this.popupMode = true;
        this.totalOf = this.images.length + this.videos.length;
        this.ready = true;
    }

    async next() {
        try {
            await this.flick.moveTo(this.flick.index + 1);
        } catch (e) {
        }
    }

    async prev() {
        try {
            await this.flick.moveTo(this.flick.index - 1);
        } catch (e) {
        }
    }

    onLoad() {
        this.imageLoading = false;
    }

    onClose() {
        this.imageLoading = true;
    }

}


